module.exports = {"id":"dp1_1l1q3","text":"Search, Browse and Filter Information","instructions":"Digital search results may include information that is not relevant.","multiselect":false,"category":"1.1","questionType":"PickOne","random":false,"options":[{"id":"dp1_1l1q3-a1","text":"True","score":1.8},{"id":"dp1_1l1q3-a2","text":"Not sure","score":0},{"id":"dp1_1l1q3-a3","text":"False","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.1/l1q3.json
// module id = 923
// module chunks = 41